import type { CartItemType } from '@/store/types/cart'
import type { GlobalStoreValues } from '@/store/useGlobalStore'
import { sendGTMEvent } from '@next/third-parties/google'
import { getEcommerceObjectForShareCart } from '../../helpers/getEccomerceObectForShareCart'

type Props = {
  globalStore: GlobalStoreValues
  cart: CartItemType[]
}

export const gtmShareCart = ({ globalStore, cart }: Props) => {
  const uuid = crypto.randomUUID()
  const { currency, value, uniqueProducts, totalProducts } =
    getEcommerceObjectForShareCart({
      globalStore,
      cart,
    })
  sendGTMEvent({
    event: 'sho_cart_share_link_copied',
    event_id: uuid,
    currency,
    cart_value: value,
    cart_unique_products_count: uniqueProducts,
    cart_quantity: totalProducts,
  })
}
